import React from 'react';
import { CountdownTimer } from './CountdownTimer';
import { PricingSelector } from './PricingSelector';
export function FinalCTA() {
  return <section className="py-12 md:py-16 px-4 bg-white border-t border-gray-100" data-id="element-114">
      <div className="max-w-2xl mx-auto" data-id="element-115">
        <div className="text-center mb-6" data-id="element-116">
          <h2 className="font-heading text-2xl md:text-3xl font-extrabold text-gray-900 mb-2" data-id="element-117">
            Última oportunidad
          </h2>
          <p className="text-sm text-gray-600 font-medium" data-id="element-118">
            No dejes que se acaben los cupos
          </p>
        </div>

        <CountdownTimer data-id="element-119" />

        <div className="mt-6 bg-gray-50 rounded-2xl p-4 md:p-6 shadow-lg border border-gray-200" data-id="element-120">
          <PricingSelector compact data-id="element-121" />
        </div>
      </div>
    </section>;
}